import compileSymbols from '~/utils/compileSymbols';
const types = [
  'REAL_TIME_PRICING_ERROR',
  'REAL_TIME_PRICING_SUCCESS',
  'SET_SWAPPED_PRINT_METHOD',
  'SHOW_SHIPPING_FORM',
  'UPDATE_COLORFUL_QUOTE',
  'UPDATE_COLOR_COUNT',
  'UPDATE_DROPPED_VIEW',
  'UPDATE_EMBROIDERY_TO_PRINT_PRICE',
  'UPDATE_HAS_FULL_QUOTE',
  'UPDATE_IS_FETCHING_PRICES_WITHOUT_DROPPED_VIEW',
  'UPDATE_IS_INVENTORY_SHIPPING_TYPE',
  'UPDATE_ITEMIZED_PRICES_WITHOUT_DROPPED_VIEW',
  'UPDATE_ITEMIZED_PRICES',
  'UPDATE_MODE',
  'UPDATE_NCO_ELIGIBILITY',
  'UPDATE_ONE_COLOR_LESS_PRICE',
  'UPDATE_ONE_VIEW_LESS_PRICE',
  'UPDATE_POSTAL_CODE',
  'UPDATE_PRODUCT_QUANTITIES',
  'UPDATE_QUANTITIES_FROM_NAMES_AND_NUMBERS',
  'UPDATE_QUOTE_BLANK',
  'UPDATE_QUOTE',
  'UPDATE_REAL_TIME_ITEMIZED_PRICES',
  'UPDATE_REAL_TIME_TOTAL_PRICE',
  'UPDATE_SHIPPING',
  'UPDATE_SLEEVE_VIEW_LESS_PRICE',
  'UPDATE_SLEEVE_VIEW_LESS_SAVE_AMOUNT',
  'UPDATE_TOTAL_PRICE',
  'UPDATE_UNAVAILABLE_CORE_SIZES'
];
export default compileSymbols(types, 'quote');
